export class ExpectedError extends Error {
  // 필요한 커스텀 데이터는 private/protected 멤버로 관리합니다.
  public detail: Record<string, any>;

  constructor(message?: string, detail: Record<string, any> = {}) {
    super(message);

    this.name = 'ExpectedError';

    this.detail = detail;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ExpectedError);
    }
  }
}
